export enum SPECIALIST_RESPONSE {
   CREATED = 'CREATED',
   EDITED = 'EDITED',
   REMOVED = 'REMOVED',
   DONE = 'DONE'
}
